export default __webpack_public_path__ + "e8b5573b5190255d53cd1d6005a5ab69.png";